import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AnimatePresence } from "framer-motion";

import React, { useEffect } from "react";
import { useDispatch, connect } from "react-redux";

import { logoutRequest, resetAppState, notificationsRequest } from './store/actions'
import { toast } from 'react-toastify';
import { STATUS } from './constant';
import RoutesContainer from "./route/Routes";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

// FUNCTION TO CHECK TOKEN
const parseJwt = (token) => {
  try {
    let jwtFirstPart = token.split(".")[1];
    //console.log(jwtFirstPart);
    return JSON.parse(atob(jwtFirstPart));
  } catch (error) {
    console.log(error);
    return null;
  }
};



// MAIN TO RENDER ROUTES AND PAGES
const App = ({
  loginStatus,
  loginResult,
  userType,
}) => {
  const dispatch = useDispatch();


  useEffect(() => {
    if (loginStatus === STATUS.SUCCESS) {
      checkTokenValidity(parseJwt(loginResult.token));
    }
  })

  // useEffect(() => {
  //   if (loginStatus === STATUS.SUCCESS){
  //     dispatch(notificationsRequest(loginResult.token));
  //   }
  // },[])

  const checkTokenValidity = (decodedJwt) => {
    if (!decodedJwt) {
      toast.warn("Not enabled User");
      dispatch(logoutRequest());
      dispatch(resetAppState())
      return;
    }

    if (decodedJwt.exp * 1000 < Date.now()) {
      toast.warn("User access timeout please login");
      dispatch(logoutRequest());
      dispatch(resetAppState())
    }
    return;
  };

  return (
    <>
      {/* <AnimatePresence mode="wait"> */}
      <RoutesContainer loginStatus={loginStatus} />
      {/* </AnimatePresence> */}
      <ToastContainer
        autoClose={3000}
        draggable={false}
        position="top-right"
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnHover
      />
    </>
  );
};

const mapStateToProps = ({ auth, user }) => {
  const {
    otpStatus: loginStatus,
    otpResult: loginResult
  } = auth;

  const { userTypes: userType } = user;

  return {
    loginStatus,
    loginResult,
    userType,
  };
};
export default connect(mapStateToProps, {})(App);

// export default App;
